window.theme.block('hero-content-image', el => {
    const image = el.querySelector('.image-wrapper .image');
    const section = el;

    // Return early if no element is present in the page
    if (!image) return;

    // Adjustable trigger percentage (e.g., 25%)
    const triggerPercentage = 0.25;

    // Listen for scroll events
    let ticking = false;

    function handleScroll() {
        const scrollTop = window.scrollY;
        const sectionTop = section.offsetTop; // Distance from top of page
        const sectionHeight = section.offsetHeight;
        const triggerPoint = window.innerHeight * triggerPercentage; // Offset from top of viewport

        // Check if the section has reached the trigger point
        if (scrollTop + triggerPoint >= sectionTop && scrollTop <= sectionTop + sectionHeight) {
            // Start zooming effect
            const progress = (scrollTop + triggerPoint - sectionTop) / sectionHeight; // Normalize scroll
            const scale = 1 + progress * 0.2; // Adjust multiplier for zoom intensity
            image.style.transform = `scale(${scale})`;
        } else if (scrollTop + triggerPoint < sectionTop) {
            // Reset zoom if the section is not yet at the trigger point
            image.style.transform = `scale(1)`;
        }

        ticking = false;
    }

    document.addEventListener('scroll', () => {
        if (!ticking) {
            requestAnimationFrame(handleScroll);
            ticking = true;
        }
    });
});
